import React, { useState } from 'react';
import { List, Modal } from "antd";
import { actions_types } from "./constants/actions";
import { connect } from "react-redux";
import { addActionToAutomaion } from "../../../../hooks/automation";

const ModalAddAction = ({ isModalOpen, hideModal, onAddActionToAutomation, saveDataFromActionAfterChangeStep, automation, addContext = null }) => {
    const { actionStep } = automation;
    const [selectedItem, setSelectedItem] = useState(null);
    const [hoveredItem, setHoveredItem] = useState(null);

    const handleOkSelectAction = () => {
        if (selectedItem) {
            const index = actions_types.findIndex(item => item.type === selectedItem);
            saveDataFromActionAfterChangeStep(actionStep);
            // addContext (vindo do canvas) define depois de qual passo e em
            // qual rota o novo passo entra.
            onAddActionToAutomation(actions_types[index], addContext);
        }

        setHoveredItem(null);
        setSelectedItem(null)
        hideModal();
    }

    const handleOnDoubleClickSelectAction = (type) => {
        setSelectedItem(type)
        handleOkSelectAction();
    }

    return (
        (<Modal
            title="Escolha o tipo da ação:"
            open={isModalOpen}
            onOk={handleOkSelectAction}
            onCancel={hideModal}
            okText="Selecionar"
            cancelText="Cancelar"
            okButtonProps={{
                disabled: selectedItem === null
            }}
        >
            <List
                dataSource={actions_types}
                renderItem={(item) => (
                    <List.Item
                        onDoubleClick={() => handleOnDoubleClickSelectAction(item.type)}
                        onClick={() => setSelectedItem(item.type)}
                        onMouseEnter={() => setHoveredItem(item.type)}
                        onMouseLeave={() => setHoveredItem(null)}
                        style={{
                            padding: "5px",
                            backgroundColor: item.type === selectedItem ? 'var(--cp-brand-soft)' : (item.type === hoveredItem ? 'var(--cp-surface-2)' : 'transparent'),
                            cursor: 'pointer',
                        }}
                    >
                        <List.Item.Meta
                            style={{ display: "flex", alignItems: "center" }}
                            avatar={item.icon}
                            title={item.name ?? item.defaultName}
                            description={item.description}
                        />
                    </List.Item>
                )}
            />
        </Modal>)
    );
}

const mapStateToProps = ({ automation }) => ({
    automation: automation,
});

const mapDispatchToProps = (dispatch) => {
    return {
        onAddActionToAutomation: (action, context = null) => dispatch(addActionToAutomaion(action, context))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ModalAddAction)
